import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { act, useEffect, useRef, useState } from "react";
import EditIcon from "../../../components/Icons/EditIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/Icons/CheckIcon";
import CrossIcon from "../../../components/Icons/CrossIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { saveActiveGrnTab, updateFiltersStates } from "../../../store/actions/UserActions";
import { Nav, NavItem, NavLink, TabContent, TabPane, Fade } from "reactstrap";
import moment from "moment";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import RequestSelectorModal from "../SiteSettings/Budget/RequestSelectorModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";

export default function BudgetRequests() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const toggle = () => {
    setModal(!modal);
  };
  const [modalDelete, setModalDelete] = useState(false);
  const toggleDelete = () => setModalDelete(!modalDelete);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("SCM");
  const activeSubTab = useSelector((state) => state?.root?.activeGrnTab);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [pageStates, setPageStates] = useState({
    sortByDate: [
      moment(moment().subtract(30, "days").toDate()).format("YYYY-MM-DD"),
      moment(moment().toDate()).format("YYYY-MM-DD"),
    ],
    tableLoader: false,
    BudgetRequestData: [],
    siteList: [],
    searchQuery: "",
    siteId: filterDetails?.siteId,
    isLoadingSite: false,
    isInitial: true,
    downloadLoading: false,
  });
  const [requestModal, setRequestModal] = useState(false);
  const toggleRequestModal = () => {
    setRequestModal(!requestModal);
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectionChange = (checked, pageRowIds) => {
    if (checked) {
      const newSelected = [...new Set([...selectedRows, ...pageRowIds])];
      setSelectedRows(newSelected);
    } else {
      setSelectedRows([]);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setPageStates((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    };
  };

  const toggleSubTab = (subTab) => {
    if (activeSubTab !== subTab) dispatch(saveActiveGrnTab(subTab));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
        pageSize: 10,
      })
    );
    setSelectedRows([]);
    if (pageStates?.siteList?.length == 0) {
      GetSiteList();
    }
  };

  useEffect(() => {
    if (pageStates.siteList.length === 0) {
      GetSiteList();
    }
    if (filterDetails?.year) {
      GetBudgetRequestList();
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.siteId,
    filterDetails?.pageSize,
    filterDetails?.orderBy,
    filterDetails?.sortByDate,
    filterDetails?.year,
    activeTab,
    activeSubTab,
    pageStates?.isInitial,
  ]);

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const GetBudgetRequestList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site_budget_request +
      MainFilterHandler({
        ...filterDetails,
        orderBy: filterDetails?.orderBy,
        searchQuery: pageStates?.searchQuery,
        siteId: pageStates?.siteId,
        ...(activeTab === "SCM" && activeSubTab && { status: activeSubTab }),
      });
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      BudgetRequestData: {},
    }));
    callApi(API + `&from=${activeTab}`, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.budgetRequest?.map((item) => ({
          ...item,
          poNumber: item?.purchase?.purchaseNumber,
          budgetRequestNumber: item?.budgetRequestNumber,
          siteName: item?.purchase?.purchaserequest?.site?.name || item?.site?.name,
          requestDate: moment(item?.createdAt).format("DD-MM-YYYY") || "--",
          requestType: item?.type === 1 ? "New Budget Request" : item?.type == 3 ? "Budget Delete Request" : "Budget Update Request" || "--",
          requestedBy: item?.user?.name,
          budgetRequestStatus: item?.status,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          BudgetRequestData: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const HandleApprove = (data) => {
    setSelectedId(data?.id);
    setModalType("approve");
    toggle();
  };
  const HandleReject = (data) => {
    setSelectedId(data?.id);
    setModalType("reject");
    toggle();
  };

  const HandleViewPO = (data) => {
    navigate(RoutesLink?.purchase_order_detail + `/${data?.purchaseId}`, {
      state: { isShow: false },
    });
  };

  const HandleViewLogs = (data) => {
    navigate(RoutesLink.budget_logs + `/${data?.id}`);
  };

  const handleReqStatus = (type, reason = "") => {
    setIsLoading(true);
    let postData = {
      from: "Account",
      status: type === "Rejected" ? "rejected" : "approved",
      ...(type === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };
    const API =
      apiUrl.update_site_budget_request_status +
      `budgetRequestId=${selectedId}`;
    callApi(API, option).then((res) => {
      setIsLoading(false);
      if (res?.status === true) {
        toast.success(res?.message);
        GetBudgetRequestList();
      } else {
        toast.error(res?.message);
      }
      toggle();
    });
  };

  const TableHeading = [
    ...(activeTab === "Account"
      ? [{ value: "poNumber", label: "PO No." }]
      : []),

    ...(activeTab === "SCM"
      ? [{ value: "budgetRequestNumber", label: "Budget Request No." }]
      : []),

    { value: "requestDate", label: "Date" },
    { value: "siteName", label: "Site" },
    { value: "requestType", label: "Type" },
    { value: "requestedBy", label: "Requested By" },
    { value: "budgetRequestStatus", label: "Status" },
  ];

  const HandleViewRequest = (data) => {
    navigate(RoutesLink?.budget_request_detail + `/${data?.id}`);
  };

  const HandleUpdateRequest = (data) => {
    // console.log(data);
    navigate(RoutesLink?.create_budget_request, {
      state: {
        data: data, type: "updates", isDisabled: true,
        ...(data?.type == 3 && { isDelete: true })
      }
    });
  }

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggleDelete();
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.delete_site_budget_request + `?budgetRequestId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggleDelete();
        GetBudgetRequestList(filterDetails?.currentPage);
      } else {
        toast.error(response?.message);
        toggleDelete();
      }
    });
  };

  const ActionDataAccount = [
    {
      label: "Approve",
      className: "btn btn-link bg-success text-white",
      icon: <CheckIcon />,
      title: "Approve",
      isSiteEditable: false,
      isShow: "pending",
      clickHandler: HandleApprove,
    },
    {
      label: "Reject",
      className: "btn btn-link bg-danger  text-white",
      icon: <CrossIcon />,
      title: "Reject",
      isSiteEditable: false,
      isShow: "pending",
      clickHandler: HandleReject,
    },
    {
      label: "View PO",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "View PO",
      clickHandler: HandleViewPO,
    },
    {
      label: "View Logs",
      className: "btn btn-link",
      icon: <DocumentIcon />,
      title: "View Logs",
      clickHandler: HandleViewLogs,
    },
  ];

  const ActionDataSCM = [
    ...((activeSubTab === "pending" && userDetails?.designation?.name !== "Director") ? [
      {
        label: "Edit",
        className: "btn btn-link",
        icon: <EditIcon />,
        title: "Edit",
        isShow: false,
        isSiteEditable: false,
        isVisible: "pending",
        type: userDetails?.type,
        loggedInUserId: userDetails?.id,
        clickHandler: HandleUpdateRequest,
      },
    ] : []),
    ...((activeSubTab === "pending" && userDetails?.designation?.name === "Director") ? [
      {
        label: "Edit",
        className: "btn btn-link",
        icon: <EditIcon />,
        title: "Edit",
        clickHandler: HandleUpdateRequest,
      },
    ] : []),
    {
      label: "View Request",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "View Request",
      clickHandler: HandleViewRequest,
    },
    {
      label: "Delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      isShow: false,
      isSiteEditable: false,
      isVisible: "pending",
      type: userDetails?.type,
      loggedInUserId: userDetails?.id,
      clickHandler: ActionHandler,
    },
  ];

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
      })
    );
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );
    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const handleCreateNew = () => {
    toggleRequestModal();
    navigate(RoutesLink.create_budget_request);
  };

  const handleEditExisting = () => {
    toggleRequestModal();
    navigate(RoutesLink.create_budget_request, {
      state: {
        type: "edit",
        isDisabled: false
      }
    });
  };
  const handleDeleteExisting = () => {
    toggleRequestModal();
    navigate(RoutesLink.create_budget_request, {
      state: {
        type: "edit",
        isDisabled: false,
        isDelete: true
      }
    });
  };

  const HandleDownloadExcel = async () => {

    const submitData = {
      ids: selectedRows,
    };

    const options = {
      method: "POST",
      data: submitData,
    };

    const API = apiUrl?.export_site_budget_request_data;

    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));

      const response = await callApi(API, options);

      if (response?.status !== true || !response?.data) {
        throw new Error(response?.message || "File URL not received");
      }

      const fileUrl = response.data;
      const fileName = "Budget_Request.xlsx";

      const fileResponse = await fetch(fileUrl);

      if (!fileResponse.ok) {
        throw new Error("Failed to fetch file");
      }

      const blob = await fileResponse.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(downloadUrl);
      toast.success("Excel downloaded successfully");
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Download failed");
    } finally {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      setSelectedRows([]);
    }
  };


  return (
    <>
      {pageStates?.downloadLoading && BgBlurLoader()}
      <div className="content">
        <MainHeading
          title={"Budget Requests"}
          buttonText={(activeTab === "SCM" && userDetails?.type !== 2) ? "Create Budget Request" : null}
          clickHandler={(activeTab === "SCM" && userDetails?.type !== 2) ? toggleRequestModal : null}
          buttonIcon={(activeTab === "SCM" && userDetails?.type !== 2) ? <PlusIcon /> : null}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />
        {(userDetails?.designation?.name === "Director" || userDetails?.type === 2) &&
          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item">
              <NavLink
                className={
                  activeTab === "SCM"
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("SCM")}
              >
                SCM
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  activeTab === "Account"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("Account")}
              >
                Accounts
              </NavLink>
            </NavItem>
          </Nav>}

        {selectedRows?.length > 0 && (
          <div className="alert alert-info d-flex justify-content-center align-items-center p-2 px-3 rounded-3">
            <div className="d-flex align-items-center gap-2">
              <i className="bi bi-check-circle-fill text-success fs-5"></i>
              <span className=" fs-5">
                Selected <strong>{selectedRows?.length}</strong> of Total{" "}
                <strong>{filterDetails?.count}</strong> Budget Requests to
                Download
              </span>
            </div>
          </div>
        )}

        <TabContent activeTab={activeTab}>
          <TabPane tabId="SCM">
            <Fade in={activeTab === "SCM"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <Nav tabs className="nav nav-tabs border-0 mb-4">
                    <NavItem className="nav-item ">
                      <NavLink
                        className={
                          activeSubTab === "pending"
                            ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0  border-end-1 border-start-1 active"
                            : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-1 border-start-1"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleSubTab("pending")}
                        disabled={pageStates?.tableLoader}
                      >
                        Pending
                      </NavLink>
                    </NavItem>
                    <NavItem className="nav-item ">
                      <NavLink
                        className={
                          activeSubTab === "approved"
                            ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-0 active"
                            : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-0"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleSubTab("approved")}
                        disabled={pageStates?.tableLoader}
                      >
                        Approved
                      </NavLink>
                    </NavItem>
                    <NavItem className="nav-item ">
                      <NavLink
                        className={
                          activeSubTab === "rejected"
                            ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                            : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleSubTab("rejected")}
                        disabled={pageStates?.tableLoader}
                      >
                        Rejected
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={activeSubTab}>
                    <TabPane tabId="pending">
                      <Fade in={activeSubTab === "pending"} timeout={200}>
                        <FilterComponent
                          handleSearch={handleSearchChange}
                          orderByHandler={orderByHandler}
                          orderByList={orderByList}
                          filterArray={sortList}
                          handleData={handleSortData}
                          getSite={GetSiteList}
                          pageStates={pageStates}
                          handleDownloadPA={
                            selectedRows?.length > 0 ? HandleDownloadExcel : ""
                          }
                        />
                        <CommonTable
                          TableHeading={TableHeading}
                          TableData={pageStates?.BudgetRequestData}
                          ActionData={ActionDataSCM}
                          currentPage={filterDetails?.currentPage}
                          PageChangeHandler={PageChangeHandler}
                          isLoading={pageStates?.tableLoader}
                          totalPages={filterDetails?.totalPages}
                          count={filterDetails?.count}
                          handleChangePageSize={handleChangePageSize}
                          pageSize={filterDetails?.pageSize}
                          selectedRows={selectedRows}
                          setSelectedRows={setSelectedRows}
                          onSelectionChange={handleSelectionChange}
                          rowKey="id"
                        />
                      </Fade>
                    </TabPane>
                    <TabPane tabId="approved">
                      <Fade in={activeSubTab === "approved"} timeout={200}>
                        <FilterComponent
                          handleSearch={handleSearchChange}
                          orderByHandler={orderByHandler}
                          orderByList={orderByList}
                          filterArray={sortList}
                          handleData={handleSortData}
                          getSite={GetSiteList}
                          pageStates={pageStates}
                          handleDownloadPA={
                            selectedRows?.length > 0 ? HandleDownloadExcel : ""
                          }
                        />
                        <CommonTable
                          TableHeading={TableHeading}
                          TableData={pageStates?.BudgetRequestData}
                          ActionData={ActionDataSCM}
                          currentPage={filterDetails?.currentPage}
                          PageChangeHandler={PageChangeHandler}
                          isLoading={pageStates?.tableLoader}
                          totalPages={filterDetails?.totalPages}
                          count={filterDetails?.count}
                          handleChangePageSize={handleChangePageSize}
                          pageSize={filterDetails?.pageSize}
                          selectedRows={selectedRows}
                          setSelectedRows={setSelectedRows}
                          onSelectionChange={handleSelectionChange}
                          rowKey="id"
                        />
                      </Fade>
                    </TabPane>
                    <TabPane tabId="rejected">
                      <Fade in={activeSubTab === "rejected"} timeout={200}>
                        <FilterComponent
                          handleSearch={handleSearchChange}
                          orderByHandler={orderByHandler}
                          orderByList={orderByList}
                          filterArray={sortList}
                          handleData={handleSortData}
                          getSite={GetSiteList}
                          pageStates={pageStates}
                          handleDownloadPA={
                            selectedRows?.length > 0 ? HandleDownloadExcel : ""
                          }
                        />
                        <CommonTable
                          TableHeading={TableHeading}
                          TableData={pageStates?.BudgetRequestData}
                          ActionData={ActionDataSCM}
                          currentPage={filterDetails?.currentPage}
                          PageChangeHandler={PageChangeHandler}
                          isLoading={pageStates?.tableLoader}
                          totalPages={filterDetails?.totalPages}
                          count={filterDetails?.count}
                          handleChangePageSize={handleChangePageSize}
                          pageSize={filterDetails?.pageSize}
                          selectedRows={selectedRows}
                          setSelectedRows={setSelectedRows}
                          onSelectionChange={handleSelectionChange}
                          rowKey="id"
                        />
                      </Fade>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId="Account">
            <Fade in={activeTab === "Account"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    filterArray={sortList}
                    handleData={handleSortData}
                    getSite={GetSiteList}
                    pageStates={pageStates}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.BudgetRequestData}
                    ActionData={ActionDataAccount}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails?.pageSize}
                  />

                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
      <ApproveRejectModal
        modal={modal}
        toggle={toggle}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject" ? "Rejected" : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
      <ConfirmModal
        modal={modalDelete}
        toggle={toggleDelete}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
      <RequestSelectorModal
        modal={requestModal}
        toggle={toggleRequestModal}
        handleCreateNew={handleCreateNew}
        handleEditExisting={handleEditExisting}
        handleDeleteExisting={handleDeleteExisting}
      />
    </>
  );
}
